export enum MESSAGE_TYPE {
  THANKS_INTENTION_PRAYER = 'thanks_intention_prayer',
}
